import React from 'react';
import { MiddleActionCard } from './MiddleActionCard';

import { FaWallet, FaUserFriends, FaUserCircle, FaUniversity, FaFileAlt, FaDownload } from 'react-icons/fa';

export const MiddleActionRow = ({ setActiveTab,userRole,setSelectedAccountType }) => {

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 my-6">
      <MiddleActionCard
        icon={<FaWallet />}
        label="My Wallet"
        sublabel="Wallet Activity"
        onClick={() => setActiveTab('wallet-deposit-widthdraw')}
      //onClick={() => navigate('/financial/wallet-deposit')}
      />
      <MiddleActionCard
        icon={<FaUniversity />}
        label="Accounts"
        sublabel="All Accounts"
        onClick={() => setActiveTab('accounts')}
      //onClick={() => navigate('/accounts')}
      />
      {
        userRole !== 7 && <MiddleActionCard
          icon={<FaUserFriends />}
          label="My Partner"
          sublabel="Partner Activity"
           onClick={() => {
            setActiveTab('accounts')
            setSelectedAccountType("partner_account")
           }}
        />
      }

      <MiddleActionCard
        icon={<FaUserCircle />}
        label="My Profile"
        sublabel="Profile Info"
        onClick={() => setActiveTab('profile')}
      //onClick={() => navigate('/profile')}
      />
      <MiddleActionCard
        icon={<FaFileAlt />}
        label="Enquiries"
        sublabel="All Support Tickets"
        onClick={() => setActiveTab('support')}
      //onClick={() => navigate('/support')}
      />
      <MiddleActionCard
        icon={<FaDownload />}
        label="Downloads"
        sublabel="All Platforms"
        onClick={() => setActiveTab('platforms')}
      //onClick={() => navigate('/platforms')}
      />
    </div>
  );
};
